<template>
  <div id="app">
    <canvas ref="starCanvas" class="pc-stars"></canvas>
    <div class="pc-glow pc-glow-1"></div>
    <div class="pc-glow pc-glow-2"></div>
    <div class="pc-glow pc-glow-3"></div>
    <div class="pc-stage">
      <router-view></router-view>
      <Footer/>
    </div>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {status:0,
    };
  },
  created(){
    this.getBaseInfo();
  },
  watch: {
    '$route.path'() {
      this.syncShell();
    }
  },
  mounted() {
    this.syncShell();
    this._onShellResize = () => this.syncShell();
    window.addEventListener('resize', this._onShellResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._onShellResize);
    this.stopStars();
    document.documentElement.classList.remove('pc-shell');
    document.documentElement.classList.remove('mobile-lite');
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        this.$store.commit('setBaseInfoValue', res.data);
      })
    },
    syncShell() {
      const path = ((this.$route && this.$route.path) || '').toLowerCase();
      const isAuthPage = path === '/login' || path === '/register';
      const desktop = window.innerWidth >= 768;
      const enabled = desktop && !isAuthPage;
      document.documentElement.classList.toggle('pc-shell', enabled);
      document.documentElement.classList.toggle('mobile-lite', !desktop);
      if (enabled) {
        this.$nextTick(() => this.startStars());
      } else {
        this.stopStars();
      }
    },
    startStars() {
      const canvas = this.$refs.starCanvas;
      if (!canvas) {
        return;
      }
      if (this._starsOn) {
        this.resizeStars();
        return;
      }
      const ctx = canvas.getContext('2d');
      this.resizeStars();
      this._particles = Array.from({ length: 35 }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: Math.random() * 1.8 + 0.5,
        alpha: Math.random() * 0.6 + 0.1,
        vx: (Math.random() - 0.5) * 0.3,
        vy: -Math.random() * 0.4 - 0.1
      }));
      this._starsOn = true;
      const tick = () => {
        if (!this._starsOn) {
          return;
        }
        const width = canvas.width;
        const height = canvas.height;
        ctx.clearRect(0, 0, width, height);
        this._particles.forEach((particle) => {
          particle.x += particle.vx;
          particle.y += particle.vy;
          if (particle.y < 0) {
            particle.y = height;
          }
          if (particle.x < 0 || particle.x > width) {
            particle.x = Math.random() * width;
          }
          ctx.beginPath();
          ctx.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(244, 216, 131, ' + particle.alpha + ')';
          ctx.shadowBlur = 8;
          ctx.shadowColor = 'rgba(212, 175, 55, 0.8)';
          ctx.fill();
        });
        this._starFrame = requestAnimationFrame(tick);
      };
      tick();
    },
    resizeStars() {
      const canvas = this.$refs.starCanvas;
      if (!canvas) {
        return;
      }
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    },
    stopStars() {
      this._starsOn = false;
      if (this._starFrame) {
        cancelAnimationFrame(this._starFrame);
        this._starFrame = 0;
      }
    }
  }
}
</script>

<style>
.pc-stars,
.pc-glow {
  display: none;
}

@media (min-width: 768px) {
  html.pc-shell,
  html.pc-shell body {
    background: #07050B;
  }

  html.pc-shell .pc-stars {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    opacity: 0.4;
  }

  html.pc-shell .pc-glow {
    display: block;
    position: fixed;
    z-index: 0;
    border-radius: 50%;
    pointer-events: none;
  }

  html.pc-shell .pc-glow-1 {
    top: -10%;
    right: -8%;
    width: 380PX;
    height: 380PX;
    background: radial-gradient(circle at 30% 30%, rgba(88, 28, 135, 0.32), rgba(212, 175, 55, 0.16) 42%, transparent 70%);
    filter: blur(90PX);
  }

  html.pc-shell .pc-glow-2 {
    bottom: -12%;
    left: -10%;
    width: 420PX;
    height: 420PX;
    background: radial-gradient(circle at 70% 40%, rgba(170, 134, 37, 0.28), rgba(30, 27, 75, 0.4) 46%, transparent 72%);
    filter: blur(100PX);
  }

  html.pc-shell .pc-glow-3 {
    top: 35%;
    left: 50%;
    width: 300PX;
    height: 300PX;
    background: rgba(217, 119, 6, 0.12);
    filter: blur(110PX);
    transform: translateX(-50%);
  }

  html.pc-shell .pc-stage {
    position: relative;
    z-index: 1;
    width: 430PX;
    max-width: calc(100vw - 48PX);
    height: calc(100vh - 48PX);
    margin: 24PX auto;
    overflow-x: hidden;
    overflow-y: auto;
    border: 1PX solid rgba(212, 175, 55, 0.2);
    border-radius: 0;
    background: rgba(12, 10, 20, 0.8);
    box-shadow: 0 0 80PX rgba(0, 0, 0, 0.9);
  }

  html.pc-shell .pc-stage > *:not(.custom-tabbar) {
    position: relative !important;
    top: auto !important;
    right: auto !important;
    bottom: auto !important;
    left: auto !important;
    width: auto !important;
    height: auto !important;
    min-height: 0 !important;
    overflow: visible !important;
    padding-bottom: 108PX !important;
  }

  html.pc-shell .page {
    position: relative !important;
    top: auto !important;
    right: auto !important;
    left: auto !important;
    height: auto !important;
    min-height: 0 !important;
  }

  html.pc-shell .hero-section,
  html.pc-shell .hero-bg,
  html.pc-shell .page-bg,
  html.pc-shell .top-glow {
    display: none !important;
    height: 0 !important;
    min-height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  html.pc-shell .van-nav-bar,
  html.pc-shell .nav-bar,
  html.pc-shell .van-nav-bar__content {
    height: 52PX !important;
    min-height: 0 !important;
    max-height: 52PX !important;
  }

  html.pc-shell .van-nav-bar__title {
    height: 52PX !important;
    font-size: 18PX !important;
    line-height: 52PX !important;
  }

  html.pc-shell .van-tabs__wrap {
    height: 52PX !important;
  }

  html.pc-shell .van-count-down {
    padding: 0 !important;
    background: transparent !important;
    color: #f3d27a !important;
    font-size: 16PX !important;
    line-height: 1.2 !important;
  }

  html.pc-shell .custom-tabbar {
    left: 50% !important;
    right: auto !important;
    bottom: 24PX !important;
    width: 430PX !important;
    max-width: calc(100vw - 48PX) !important;
    transform: translateX(-50%);
    border-radius: 0;
  }

  html.pc-shell .van-popup--bottom,
  html.pc-shell .van-popup--top,
  html.pc-shell .van-number-keyboard,
  html.pc-shell .bottom-actions,
  html.pc-shell .bottom-fixed {
    left: calc(50vw - 215PX) !important;
    right: auto !important;
    width: 430PX !important;
    max-width: calc(100vw - 48PX) !important;
    margin-left: 0 !important;
    box-sizing: border-box !important;
  }

  html.pc-shell .bottom-actions,
  html.pc-shell .bottom-fixed {
    bottom: 24PX !important;
  }

  html.pc-shell .action-bar .cart-icon {
    width: 40PX !important;
    height: 40PX !important;
  }

  html.pc-shell .action-bar .balance-info .label,
  html.pc-shell .action-bar .balance-info .unit,
  html.pc-shell .action-bar .balance-info .amount,
  html.pc-shell .submit-btn,
  html.pc-shell .confirm-btn {
    font-size: 14PX !important;
  }

  html.pc-shell .submit-btn,
  html.pc-shell .confirm-btn {
    padding: 10PX 16PX !important;
    border-radius: 8PX !important;
  }

  html.pc-shell body .van-toast,
  html.pc-shell .van-toast {
    max-width: 360PX !important;
  }

  html.pc-shell .van-empty {
    justify-content: flex-start !important;
    padding: 48PX 16PX 24PX !important;
  }

  html.pc-shell .van-empty__image {
    width: 120PX !important;
    height: 120PX !important;
    overflow: hidden;
  }

  html.pc-shell .van-empty__image img,
  html.pc-shell .van-empty__image svg {
    width: 120PX !important;
    height: 120PX !important;
  }

  html.pc-shell .van-empty__description {
    margin-top: 12PX !important;
    padding: 0 12PX !important;
    color: rgba(249, 234, 184, 0.62) !important;
    font-size: 13PX !important;
    line-height: 1.5 !important;
  }
}

body .van-toast {
  flex-direction: row;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  width: auto !important;
  max-width: 84vw !important;
  min-width: 0 !important;
  min-height: 0 !important;
  padding: 8PX 14PX !important;
  color: #fff !important;
  font-size: 18PX !important;
  line-height: 1 !important;
  white-space: nowrap !important;
  word-break: keep-all !important;
  text-align: center !important;
  background: rgba(255, 255, 255, 0.08) !important;
  background-color: rgba(255, 255, 255, 0.08) !important;
  border: 1PX solid rgba(255, 255, 255, 0.16) !important;
  border-radius: 999PX !important;
  backdrop-filter: blur(10PX);
  box-shadow: none !important;
  text-shadow: none !important;
}
body .van-toast .van-toast__text {
  order: 1;
  margin-top: 0 !important;
  font-size: 18PX !important;
  line-height: 1 !important;
  white-space: nowrap !important;
}
body .van-toast--text .van-toast__icon,
body .van-toast--html .van-toast__icon,
body .van-toast--success .van-toast__icon,
body .van-toast--fail .van-toast__icon {
  display: none !important;
}
body .van-toast.van-toast--text,
body .van-toast.van-toast--html,
body .van-toast.van-toast--success,
body .van-toast.van-toast--fail {
  width: auto !important;
  min-width: 0 !important;
  min-height: 0 !important;
  padding: 8PX 14PX !important;
  background: rgba(255, 255, 255, 0.08) !important;
  background-color: rgba(255, 255, 255, 0.08) !important;
  border-radius: 999PX !important;
  box-shadow: none !important;
}
*, :after, :before {
  box-sizing: border-box;
}

button,
a,
[role="button"],
.van-tab,
.van-tabbar-item {
  touch-action: manipulation;
}

@media (max-width: 767px) {
  html.mobile-lite .particle-canvas,
  html.mobile-lite .pc-stars,
  html.mobile-lite .pc-glow,
  html.mobile-lite .home-page .glow,
  html.mobile-lite .lux-page .glow {
    display: none !important;
  }

  html.mobile-lite .lux-page .logo-shell,
  html.mobile-lite .lux-page .login-btn::before {
    animation: none !important;
  }

  html.mobile-lite .custom-tabbar,
  html.mobile-lite [class*="card"],
  html.mobile-lite .panel-card,
  html.mobile-lite .tip-card,
  html.mobile-lite .van-popup {
    -webkit-backdrop-filter: none !important;
    backdrop-filter: none !important;
  }
}
</style>
